// src/components/Navbar.js
import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const closeMenu = () => setOpen(false);
  const toggleMenu = () => setOpen((v) => !v);

  // Ferme le menu à chaque changement de page
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  // Empêche le scroll quand le menu est ouvert (mobile)
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  // Fermer le menu avec Échap (pro + accessibilité)
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") closeMenu();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <header className="Navbar">
      <div className="container nav-inner">
        {/* Brand */}
        <Link to="/" className="nav-logo" aria-label="Accueil" onClick={closeMenu}>
          <div className="brand">
            <img
              src="/images/logo.png"
              alt="Logo Maxime H"
              className="brand-icon"
              loading="eager"
              decoding="async"
            />
            <img
              src="/images/MaximeH.png"
              alt="Maxime H — Photographe culinaire"
              className="brand-wordmark"
              loading="eager"
              decoding="async"
            />
          </div>
        </Link>

        {/* Burger (mobile) */}
        <button
          type="button"
          className={`nav-toggle ${open ? "is-open" : ""}`}
          aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
          aria-expanded={open}
          aria-controls="mainmenu"
          onClick={toggleMenu}
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>

        {/* Menu */}
        <nav
          id="mainmenu"
          className={`nav-menu ${open ? "open" : ""}`}
          aria-label="Navigation principale"
        >
          <NavLink
            to="/"
            end
            className={({ isActive }) => (isActive ? "nav-link is-active" : "nav-link")}
            onClick={closeMenu}
          >
            Accueil
          </NavLink>

          <NavLink
            to="/galerie"
            className={({ isActive }) => (isActive ? "nav-link is-active" : "nav-link")}
            onClick={closeMenu}
          >
            Galerie
          </NavLink>

          <NavLink
            to="/services"
            className={({ isActive }) => (isActive ? "nav-link is-active" : "nav-link")}
            onClick={closeMenu}
          >
            Services
          </NavLink>

          <NavLink
            to="/about"
            className={({ isActive }) => (isActive ? "nav-link is-active" : "nav-link")}
            onClick={closeMenu}
          >
            À propos
          </NavLink>

          <NavLink
            to="/contact"
            className={({ isActive }) => (isActive ? "nav-link is-active" : "nav-link")}
            onClick={closeMenu}
          >
            Contact
          </NavLink>

          <NavLink
            to="/acces-clients"
            className={({ isActive }) => (isActive ? "nav-link is-active" : "nav-link")}
            onClick={closeMenu}
          >
            Accès clients
          </NavLink>
        </nav>
      </div>

      {/* Backdrop mobile */}
      {open && <div className="nav-backdrop" onClick={closeMenu} />}
    </header>
  );
}